<template>
    <div class="coin-icon">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            :fill="colors.theme == 'dark' ? colors.primary : '#000'"
            viewBox="0 0 78 91" style="enable-background:new 0 0 78 91;" xml:space="preserve">
            <g>
                <path class="st0" d="M63.24,28.54c-4.66-5.58-11.09-9.63-18.42-11.28v-6.57h4.89V1.55H23.42v9.13h5.08v6.97
                    c-3.28,0.91-6.36,2.3-9.16,4.1l-6.24-6.24L1.48,27.14l6.61,6.61C5.41,38.57,3.88,44.11,3.88,50c0,10.79,5.12,20.4,13.06,26.55
                    c6.41,7.76,15.77,12.2,25.88,12.2c18.51,0,33.57-15.06,33.57-33.57C76.39,44.66,71.59,34.95,63.24,28.54z M25.42,8.68V3.55H47.7
                    v5.13h-2.89H28.5H25.42z M30.5,10.68h12.31v6.18c-1.75-0.28-3.54-0.43-5.37-0.43c-2.38,0-4.7,0.25-6.95,0.73V10.68z M4.31,27.14
                    l8.8-8.8l4.56,4.56c-3.37,2.47-6.27,5.55-8.52,9.08L4.31,27.14z M5.88,50c0-17.41,14.16-31.57,31.57-31.57S69.02,32.59,69.02,50
                    S54.86,81.57,37.45,81.57c-7.17,0-13.79-2.41-19.1-6.45c-0.17-0.21-0.36-0.42-0.52-0.64l-0.15,0.11C10.49,68.8,5.88,59.93,5.88,50z
                    M42.82,86.75c-6.61,0-12.87-2.02-18.11-5.7c3.93,1.62,8.23,2.52,12.74,2.52c18.51,0,33.57-15.06,33.57-33.57
                    c0-4.93-1.08-9.61-2.99-13.83c4.1,5.41,6.36,12.02,6.36,19.01C74.39,72.59,60.22,86.75,42.82,86.75z"/>
                <polygon class="st0" points="52.43,62.01 38.45,49.55 38.45,29.68 36.45,29.68 36.45,50.45 51.1,63.51 	"/>
            </g>
        </svg>

    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
        // console.log('Colors: ', this.colors)
    }       
}
</script>

<style lang="scss" scoped>
// .cls-3{fill:#00aa95;}.cls-4{fill:#606;}.cls-9{fill:url(#linear-gradient-3);}.cls-7{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path);}
.cls-1{fill:none;}.cls-2{opacity:0.15;}.cls-10{fill:#fff;}
</style>
